/* @vue/component */
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Returnable',

  props: {
    returnValue: {
      type: null,
      default: undefined,
    },
  },

  data() {
    return {
      originalValue: this.returnValue,
      returnResovers: [],
    }
  },

  methods: {
    return(value) {
      this.originalValue = value
      this.$root.$emit('submit', this.originalValue)
      this.$emit('submit', this.originalValue)
    },
  },
}
